import React from "react";
import "../patches.css";
import ServiceCard from './ServiceCard';

import { GoMoveToTop } from "react-icons/go";

const patchesData = [
  { title: "3-D EMBROIDERED", img: "https://store.logounlimited.com/cdn/shop/files/1545013604.jpg?v=1720210099&width=600" },
  { title: "EMBROIDERED", img: "https://store.logounlimited.com/cdn/shop/files/embroidered--im-10-1030-722.png?v=1720210115&width=600" },
  { title: "WOVEN", img: "https://store.logounlimited.com/cdn/shop/files/women.png?v=1720210164&width=600" },
  { title: "SUBLIMATION", img: "https://store.logounlimited.com/cdn/shop/files/print-stitch-10-gallery.png?v=1720210193&width=600" },
  { title: "BEVELED", img: "https://store.logounlimited.com/cdn/shop/files/Asset-18.png?v=1720210231&width=600" },
  { title: "RUBBER", img: "https://store.logounlimited.com/cdn/shop/files/Asset-3.png?v=1720210252&width=600" },
  { title: "LEATHER", img: "https://store.logounlimited.com/cdn/shop/files/Asset-9.png?v=1720210276&width=600" },
  { title: "TEXTURED", img: "https://store.logounlimited.com/cdn/shop/files/Asset-8.png?v=1720210313&width=600" },
  { title: "MATTE", img: "https://store.logounlimited.com/cdn/shop/files/fs-flat-website---08.png?v=1720210346&width=600" },
  { title: "HOLOGRAPHIC", img: "https://store.logounlimited.com/cdn/shop/files/fs-holographic-website---05.png?v=1720210364&width=600" },
];

const Patches = () => {
  return (
          <><ServiceCard
          id="#"
          title="Patches"
          description="Patches applied to clothing items like sweatshirts, shirts, jackets, and hats can significantly enhance their overall appearance by adding a distinctive, personalized, and stylish touch that helps each piece stand out and reflect individual character or branding."
          fullDescription={` Patches can significantly enhance accessories like bags, totes, and other flat items by adding a distinctive, customized touch that makes each piece more visually appealing and unique.

They are also widely used in sportswear due to their durability and high level of customization, making them a practical and popular choice for athletic apparel that needs to withstand frequent use while still showcasing team identity, branding, or personal style.`}
          images={[]} /><div id="patches-section">
              <ul
                  className="multicolumn-list grid grid--2-col-tablet-down grid--5-col-desktop"
                  role="list"
              >
                  {patchesData.map((item, index) => (
                      <li
                          key={index}
                          className="multicolumn-list__item grid__item center"
                          style={{ "--animation-order": index }}
                      >
                          <div className="multicolumn-card content-container">
                              <div className="multicolumn-card__image-wrapper">
                                  <div className="media media--transparent media--square">
                                      <img
                                          src={item.img}
                                          alt={item.title}
                                          className="multicolumn-card__image" />
                                  </div>
                              </div>

                              <div className="multicolumn-card__info">
                                  <h3 className="inline-richtext">
                                      <strong>{item.title}</strong>
                                  </h3>
                              </div>
                          </div>
                      </li>
                  ))}
              </ul>
                    <div className="emb-top">
                      <a href="#" className="top-link">
                        <GoMoveToTop size={30} />
                        <span>Top</span>
                      </a>
                    </div>
          </div></>
  );
};

export default Patches;